export default{
    methods: {
        map_question_type(type) {
            const type_map = new Map([
                ['short_text', 'text'],
                ['long_text', 'textarea'],
                ['single_select', 'single_select'],
                ['radio', 'single_select'],
                ['multi_select', 'multi_select'],
                ['checkboxes', 'multi_select'],
                ['file', 'file'],
                ['number', 'number'],
                ['date', 'date'],
                ['facial_verification', 'facial_verification']
            ]);

            return type_map.get(type) || 'text';
        },

        normalize_value(value) {
            if (value === null || value === undefined) return '';
            return String(value).trim().toLowerCase();
        },

        get_choice_text_from_value(field, value) {
            if (!value) return '';

            if (Array.isArray(value)) {
                return value.map(val => {
                const option = field.options?.find(opt =>
                    String(opt.value) === String(val) ||
                    String(opt.text).toLowerCase() === String(val).toLowerCase()
                );
                return option ? option.text : val;
                }).join(', ');
            } else {
                const option = field.options?.find(opt =>
                String(opt.value) === String(value) ||
                String(opt.text).toLowerCase() === String(value).toLowerCase()
                );
                return option ? option.text : value;
            }
        },

        process_field(field, answers, file_uploads) {
            const val = Reflect.get(this.safe_form_data, field.model);

            if (field.type === 'file' || field.type === 'facial_verification') {
                const comment = Reflect.get(this.safe_form_data, field.model + '_file_comment');

                if (val?.file) {
                    file_uploads.push({ file: val.file, id: field.section_question_id });
                    answers.push({
                        section_question_id: field.section_question_id,
                        answer_text: val.file.name,
                        question_comment: null,
                    });
                } else if (val?.original_url) {
                    answers.push({
                        section_question_id: field.section_question_id,
                        answer_text: val.original_url,
                        question_comment: null,
                    });
                }
                else if (comment !== null) {
                    answers.push({
                        section_question_id: field.section_question_id,
                        answer_text: null,
                        question_comment: comment,
                    });
                }
            } else if (field.type === 'multi_select') {
                const answer_text = this.get_choice_text_from_value(field, val);
                answers.push({
                section_question_id: field.section_question_id,
                answer_text: answer_text
                });
            } else if (field.type === 'single_select' || field.type === 'radio') {
                const answer_text = this.get_choice_text_from_value(field, val);
                answers.push({
                section_question_id: field.section_question_id,
                answer_text: answer_text
                });
            } else {
                answers.push({
                section_question_id: field.section_question_id,
                answer_text: (val || '').toString().trim()
                });
            }

            field.dependent_questions.forEach(dq => {
                if (dq.is_visible) {
                const dq_val = Reflect.get(this.safe_form_data, dq.model);

                if (dq.type === 'file' || dq.type === 'facial_verification') {
                    const comment = Reflect.get(this.safe_form_data, dq.model + '_file_comment');
                    if (dq_val?.file) {
                    file_uploads.push({ file: dq_val.file, id: dq.section_question_id });
                    answers.push({
                        section_question_id: dq.section_question_id,
                        answer_text: dq_val.file.name
                    });
                    } else if (dq_val?.original_url) {
                    answers.push({
                        section_question_id: dq.section_question_id,
                        answer_text: dq_val.original_url
                    });
                    }
                    else if (comment !== null) {
                        answers.push({
                            section_question_id: dq.section_question_id,
                            answer_text: null,
                            question_comment: comment,
                        });
                    }
                } else if (dq.type === 'multi_select') {
                    const answer_text = this.get_choice_text_from_value(dq, dq_val);
                    answers.push({
                    section_question_id: dq.section_question_id,
                    answer_text: answer_text
                    });
                } else if (dq.type === 'single_select' || dq.type === 'radio') {
                    const answer_text = this.get_choice_text_from_value(dq, dq_val);
                    answers.push({
                    section_question_id: dq.section_question_id,
                    answer_text: answer_text
                    });
                } else {
                    answers.push({
                    section_question_id: dq.section_question_id,
                    answer_text: (dq_val || '').toString().trim()
                    });
                }
                }
            });
        },

        validate_required_fields(section) {
            const errors = {};
            section.fields.forEach(field => {
                if (field.is_dependent) return;
                const value = Reflect.get(this.safe_form_data, field.model);
                const comment = Reflect.get(this.safe_form_data, field.model + '_file_comment');
                const is_comment_empty = !comment || comment.toString().trim() === '';

                if (field.required) {
                    // If it's a file field, we need EITHER a value OR a comment
                    if (field.type === 'file') {
                        if (!value && is_comment_empty) {
                            Reflect.set(errors, field.model, `This field is mandatory`);
                        }
                    } 
                    // For everything else, only value is checked
                    else if (!value || (Array.isArray(value) && value.length === 0)) {
                        Reflect.set(errors, field.model, `This field is mandatory`);
                    }
                }
                
                if (field.dependent_questions && field.dependent_questions.length) {
                field.dependent_questions.forEach(dq => {
                    const dependent_question_value = Reflect.get(this.safe_form_data, dq.model);
                    const dependent_question_comment = Reflect.get(this.safe_form_data, dq.model + '_file_comment');
                    const is_dep_comment_empty = !dependent_question_comment || dependent_question_comment.toString().trim() === '';
                    if (dq.is_visible && dq.required) {
                       if (dq.type === 'file') {
                            if (!dependent_question_value && is_dep_comment_empty) {
                                Reflect.set(errors, dq.model, `This field is mandatory`);
                            }
                        }
                        else if (!dependent_question_value || (Array.isArray(dependent_question_value) && dependent_question_value.length === 0)) {
                            Reflect.set(errors, dq.model, `This field is mandatory`);
                    } 
                    }
                    
                });
                }
            });
            return errors;
        },
    }
}